import { render } from "./HistoricoRequsicionesCarrusel.vue?vue&type=template&id=59d0bedc&scoped=true"
import script from "./HistoricoRequsicionesCarrusel.vue?vue&type=script&lang=js"
export * from "./HistoricoRequsicionesCarrusel.vue?vue&type=script&lang=js"

import "./HistoricoRequsicionesCarrusel.vue?vue&type=style&index=0&id=59d0bedc&scoped=true&lang=css"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\4\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d0bedc"]])

export default __exports__